import { Field } from "formik";
import clsx from "clsx";
import PropTypes from 'prop-types';

export const FormikInputWithIcon = ({
    id,
    type = 'text',
    label,
    labelHidden = false,
    placeholder,
    touched,
    error,
    className,
    onChange,
    onBlur,
    iconSpanClass,
    showIcon = true,
    validate,
    iconClassName,
    divClass,
    isCheckValid,
    isInvalid: _isInvalid,
    ariaRequired = false,
    ...otherProps
}) => {
    const styles = clsx(
        "form-control form-control-grey",
        className ? className : ''
    );
    const iconClass = clsx(
        "form-group-icon-in",
        iconClassName ? iconClassName : ''
    )
    const wrapperClass = clsx(
        "form-group-in",
        divClass ? divClass : ''
    )
    const showError = Boolean(touched && error);
    const errorId = `${id}-error`;

    return (
        <div className="form-group">
            {label && (
                <label htmlFor={id} className={labelHidden ? 'visually-hidden' : 'form-label'}>
                    {label}
                </label>
            )}
            <div className={wrapperClass}>
                <Field
                    {...otherProps}
                    id={id}
                    data-testid={id}
                    className={styles}
                    placeholder={placeholder}
                    name={id}
                    type={type}
                    onChange={onChange}
                    onBlur={onBlur}
                    validate={validate}
                    touched={touched && touched.toString()}
                    aria-invalid={showError || undefined}
                    aria-describedby={showError ? errorId : undefined}
                    aria-required={ariaRequired || undefined}
                />
                {showIcon &&
                    <span className={clsx("form-group-icon bg-none",
                        (isCheckValid) ? iconSpanClass : "")}>
                        <span className={iconClass}></span>
                    </span>
                }
            </div>
            {showError && <div id={errorId} role="alert" className="validation-error">{error}</div>}
        </div>
    );
}

FormikInputWithIcon.propTypes = {
    id: PropTypes.string,
    type: PropTypes.string,
    label: PropTypes.node,
    labelHidden: PropTypes.bool,
    placeholder: PropTypes.string,
    touched: PropTypes.any,
    error: PropTypes.any,
    className: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    iconSpanClass: PropTypes.string,
    showIcon: PropTypes.bool,
    validate: PropTypes.func,
    iconClassName: PropTypes.string,
    divClass: PropTypes.string,
    isCheckValid: PropTypes.any,
    isInvalid: PropTypes.any,
    ariaRequired: PropTypes.bool,
}
